import orgs from './orgs';
import budgets from './budgets';
import industries from './industries';
import regions from './regions';
import provinces from './provinces';
import kdbs from './kdbs';
import paymenyskils from './paymenyskils';
import payers from './payers';
import contracts from '../documents/contracts';
import accounts from './accounts';
import users from './users';
import profiles from './profiles';
import markers from './markers';
import inflationindex from './inflationIndex';
import calculatedcontracts from '../documents/calculatedcontracts';
import enteringtheremainder from '../documents/enteringtheremainder';
import attributes from './attributes';
import landcategories from './landcategories';
import kveds from './kveds';
import realty from './realty';
import lands from './lands';
import zones from './zones';
import salaries from './salaries';
import localities from './localities';
import specialpurpose from './specialpurpose';
import districts from './districts';
import areas from './areas';
import streets from './streets';
import houses from './houses';
import stateproperties from './stateproperties';
import budgetaryinstitutions from './budgetaryinstitutions';
import easements from './easements';
import householdMembers from './householdMembers';
import sessiondecision from './sessiondecision';
import landcertificate from './landcertificate';
import percentForTaxLand from './percentForTaxLand';

export default {
  orgs,
  budgets,
  industries,
  regions,
  kdbs,
  paymenyskils,
  payers,
  contracts,
  accounts,
  users,
  profiles,
  provinces,
  landcategories,
  markers,
  inflationindex,
  calculatedcontracts,
  enteringtheremainder,
  attributes,
  kveds,
  realty,
  lands,
  zones,
  salaries,
  localities,
  specialpurpose,
  districts,
  areas,
  streets,
  houses,
  stateproperties,
  easements,
  budgetaryinstitutions,
  householdMembers,
  sessiondecision,
  landcertificate,
  percentForTaxLand,
};
